import config from '../../config.json';

/**
 * True only when running in DEV (config.appMode) — never in acc/prod (see
 * config.json vs config.prod.json). Gate for verbose debug-only logging
 * (e.g. OutputMsgWidget cat 'Debug' hover/drag traces) that would flood
 * the log or leak internals in a real environment.
 */
export const DEBUG_LOGGING_ENABLED = config.appMode === 'DEV';
